import { React, useEffect } from "react";
import styles from "./SharedFile.module.scss";
import FileCard from "../FIleCard/FileCard";
import Loader from "../Loader/Loader";
import { useSelector, useDispatch } from "react-redux";
import { fetchSharedFiles } from "../service/apiService";
import { fetchFilesRequest } from "../../Redux/Files/FileActions";
function SharedFile(props) {
  const dispatch = useDispatch();
  const sharedFilesData = useSelector((state) => state.allFiles);
  const userData = useSelector((state) => state.user);
  let userEmail = userData && userData.email && userData.email;

  useEffect(() => {
    console.log(userEmail);
    dispatch(fetchFilesRequest());
    dispatch(fetchSharedFiles(userEmail));
  }, []);

  return sharedFilesData && sharedFilesData.loading ? (
    <div>
      <Loader />
    </div>
  ) : (
    <>
      {/* <ShortMSG /> */}
      {sharedFilesData &&
      sharedFilesData.sharedFiles &&
      sharedFilesData.sharedFiles.length !== 0 ? (
        <div className={`container ${styles.SharedFilesList}`}>
          {sharedFilesData &&
            sharedFilesData.sharedFiles &&
            sharedFilesData.sharedFiles.map((file) => {
              return (
                <FileCard
                  key={file._id}
                  file={file}
                  filesList={
                    sharedFilesData &&
                    sharedFilesData.sharedFiles &&
                    sharedFilesData.sharedFiles
                  }
                  impHandler={props.impHandler}
                  deleteHandler={props.deleteHandler}
                  page={"sharedFiles"}
                />
              );
            })}
        </div>
      ) : (
        <h1 className={styles.noFileMessage}> You have no shared Files </h1>
      )}
    </>
  );
}

export default SharedFile;
